import React from "react";
import { FaWhatsapp, FaInstagram, FaFacebook } from "react-icons/fa";
import "./FloatingSocials.css";

export default function FloatingSocials() {
  const phoneNumber = "+919182643439";
  const whatsappLink = `https://wa.me/${phoneNumber.replace("+", "")}`;

  return (
    <div className="social-float-container">
      <a
        href="https://www.facebook.com/share/1J9E6Fn9tW/"
        className="float-icon float-facebook"
        target="_blank"
        rel="noreferrer"
      >
        <FaFacebook />
      </a>
      <a
        href="https://www.instagram.com/elitecare_physio_and_rehab?igsh=MWgyNnNpYnE2cG5mcQ=="
        className="float-icon float-instagram"
        target="_blank"
        rel="noreferrer"
      >
        <FaInstagram />
      </a>
      <a
        href={whatsappLink}
        className="float-icon float-whatsapp"
        target="_blank"
        rel="noreferrer"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}
